function initializeGripStory(section) {
  const benefits = section.querySelector('[data-grip-benefits]');
  if (!benefits || benefits.dataset.gripTabsReady === 'true') return;

  const tablist = benefits.querySelector('[data-grip-tablist]');
  const tabs = Array.from(benefits.querySelectorAll('[data-grip-tab]'));
  const panels = Array.from(benefits.querySelectorAll('[data-grip-panel]'));
  if (!tablist || tabs.length === 0 || tabs.length !== panels.length) return;

  const matchingPanels = tabs.map((tab) => panels.find((panel) => panel.dataset.gripPanel === tab.dataset.gripTab));
  if (matchingPanels.some((panel) => !panel)) return;

  const selectTab = (index, moveFocus = false) => {
    tabs.forEach((tab, tabIndex) => {
      const selected = index === tabIndex;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      matchingPanels[tabIndex].hidden = !selected;
    });
    if (moveFocus) tabs[index].focus({ preventScroll: true });
  };

  tablist.setAttribute('role', 'tablist');
  tablist.setAttribute('aria-orientation', 'horizontal');
  tabs.forEach((tab, index) => {
    const panel = matchingPanels[index];
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', panel.id);
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', tab.id);
    panel.tabIndex = 0;

    tab.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      selectTab(index);
    });

    tab.addEventListener('keydown', (event) => {
      let nextIndex;
      const rtl = getComputedStyle(tablist).direction === 'rtl';
      if (event.key === 'ArrowRight') nextIndex = (index + (rtl ? -1 : 1) + tabs.length) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index + (rtl ? 1 : -1) + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (event.key === ' ') nextIndex = index;
      if (nextIndex === undefined) return;
      event.preventDefault();
      selectTab(nextIndex, true);
    });
  });

  const requestedPanelIndex = matchingPanels.findIndex((panel) => `#${panel.id}` === window.location.hash);
  selectTab(requestedPanelIndex >= 0 ? requestedPanelIndex : 0);
  benefits.dataset.gripTabsReady = 'true';
}

function initializeGripStories(scope = document) {
  if (scope.matches?.('[data-grip-story]')) initializeGripStory(scope);
  scope.querySelectorAll('[data-grip-story]').forEach(initializeGripStory);
}

initializeGripStories();
document.addEventListener('shopify:section:load', (event) => initializeGripStories(event.target));
